module.exports = __webpack_public_path__ + "static/media/proces_05.11b0c1d0.svg";